
const GetNpsAdminReducer = (state = { type: 'LOADING_NPS_ADMIN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NPS_ADMIN_ACTION':
            return action
        default:
            return state
    }
}


export {
    GetNpsAdminReducer
}